import React from 'react'

const Regularizations = (): JSX.Element => <div>Regularizations</div>

export default Regularizations
